import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const StoreOrdersBiSection = "/reports/omi/store-orders";

export const StoreOrdersBiListPath = StoreOrdersBiSection;

export enum StoreOrdersBiListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType",
  isPayoutEligible = "isPayoutEligible",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo"
}

export enum StoreOrdersBiListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  deliveryType = "deliveryType",
  orderStatus = "orderStatus"
}

export type StoreOrdersBiListUrlDialog = "download" | TabActionDialog;
export type storeOrdersBiListUrlFilters = Filters<
  StoreOrdersBiListUrlFiltersEnum
> &
  FiltersWithMultipleValues<StoreOrdersBiListUrlFiltersWithMultipleValues>;

export type StoreOrdersBiUrlQueryParams = ActiveTab &
  storeOrdersBiListUrlFilters &
  BulkAction &
  Dialog<StoreOrdersBiListUrlDialog> &
  Pagination &
  SingleAction;

export const storeOrdersBiListUrl = (params?: StoreOrdersBiUrlQueryParams) =>
  StoreOrdersBiListPath + "?" + stringifyQs(params);
